<template>
  <div id="findMyInfo">
    <div class="container">
      <div class="row">
        <div class="col-lg-offset-4 col-md-offset-3 col-sm-offset-2 col-lg-4 col-md-6 col-sm-8 col-xs-12">
          <h1 class="title">계정찾기</h1>
          <p class="description">비밀번호를 초기화해서 가입시 등록한 메일로 보내드립니다.</p>
          <form @submit.prevent="onSubmit">
            <div class="form-group">
              <label>사업자 등록번호 <small class="require-tag">*</small></label>
              <div>
                <input type="text"
                       class="hz-input-default hz-input-lg"
                       data-vv-name="crn"
                       v-validate="{required: true, min: 10, max: 12, regex: '^[0-9]{3}-[0-9]{2}-[0-9]{5}'}"
                       v-model="data['crn']" placeholder="000-00-00000"
                       v-mask="'###-##-#####'"
                       :readonly="isSending"
                >
                <p class="is-invalid-text">{{ errors.first('crn') }}</p>
              </div>
            </div>
            <div class="form-group margin-bottom-32">
              <div>
                <label>담당자 이메일 <small class="require-tag">*</small></label>
              </div>
              <div>
                <input type="text"
                       class="hz-input-default hz-input-lg"
                       data-vv-name="email"
                       v-validate="{required: true, email: true}"
                       v-model="data['pic_email']"
                       placeholder="담당자 이메일을 입력해주세요."
                       :readonly="isSending"
                >
                <p class="is-invalid-text">{{ errors.first('email') }}</p>
              </div>
            </div>
            <p class="is-invalid-text" style="margin: 0 0 16px;" v-show="isInvalid">{{ invalidText }}</p>
            <div class="text-center margin-bottom-40">
              <button type="submit" class="hz-btn-primary hz-btn-lg" :disabled="isSending">확인</button>
            </div>
          </form>
          <div class="text-center">
            <router-link :to="{name: 'contact'}" class="contact-link">계정 찾기에 실패하셨나요?</router-link>
          </div>
        </div>
      </div>
    </div>
    <!-- 가입완료 알림 -->
    <modal ref="registerModal" :id="registerModal.id" :type="registerModal.type" :title="registerModal.title"
           :size="registerModal.size" :fields="registerModal.fields"></modal>
  </div>
</template>

<script>
  import InputField from 'common/components/InputText'
  import Modal from 'common/components/Modal'
  import { mapActions } from 'vuex'
  import api from '@/api/user'

  export default {
    name: 'findmyinfo',
    components: {
      InputField,
      Modal
    },
    data () {
      return {
        isSending: false,
        isInvalid: false,
        invalidText: '',
        data: {
          crn: '',
          pic_email: ''
        },
        registerModal: {
          id: 'registerModal',
          type: 'alert',
          title: '알림',
          size: 'modal-sm',
          fields: [
            {
              type: 'message',
              message: ['등록하신 메일 주소로 변경된 비밀번호와 아이디를 성공적으로 발송했습니다', '로그인 페이지로 이동합니다.'],
              class: 'text-center'
            }
          ]
        }
      }
    },
    watch: {
      'data': {
        handler () {
          if (this.isInvalid) {
            this.isInvalid = false
          }
        },
        deep: true
      }
    },
    methods: {
      ...mapActions([
        'showToastMessage'
      ]),
      onSubmit () {
        this.$validator.validateAll()

        this.$nextTick(() => {
          // 발생된 에러가 없을 경우, 회원가입 API 실행
          if (!this.errors.any()) {
            this.isSending = true
            api.findMyInfo(this.data, response => {
              this.isSending = false
              if (response.error) {
              } else {
                if (response.code === 'VD') {
                  this.isInvalid = true
                  this.invalidText = response.message.toString()
                } else {
                  this.$refs.registerModal.show()
                  $('#registerModal').on('hidden.bs.modal', () => {
                    this.$router.push({name: 'login'})
                  })
                }
              }
            })
          }
        })
      }
    },
    beforeDestroy: function () {
      kendo.destroy(document.body)
    }
  }
</script>

<style lang="scss" scoped>
  #findMyInfo {
    .container {
      padding: 96px 16px 0;

      @media (max-width: $screen-xs-max) {
        padding: 48px 16px 0;
      }
    }

    .title {
      margin: 0 0 16px;
      font-size: 32px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.25;
      letter-spacing: -1.3px;
      text-align: center;
      color: $font-color;
    }

    .description {
      margin: 0 0 48px;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.14;
      letter-spacing: -0.8px;
      text-align: center;
      color: #5d656e;
    }

    .form-group {
      margin: 0 0 24px;

      label {
        margin: 0 0 8px;
        font-size: 14px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.43;
        letter-spacing: -0.35px;
        color: #535a62;
      }

      input {
        width: 100%;
      }
    }

    button {
      width: 167px;

      @media (max-width: $screen-xs-max) {
        width: 100%;
      }
    }

    .contact-link {
      font-size: 14px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.43;
      letter-spacing: -0.35px;
      color: $font-color;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/FindMyInfo.vue